export default __webpack_public_path__ + "static/media/014-chocolate milk.503e1d73.svg";